import { render } from "./IconJulmar.vue?vue&type=template&id=7746f8a4"
import script from "./IconJulmar.vue?vue&type=script&lang=js"
export * from "./IconJulmar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__